module.exports = __webpack_public_path__ + "img/proses_sti.c0a54edf.svg";